module.exports = __webpack_public_path__ + "img/location-neue.76daf4a8.png";